<rpshared-save-bar
	[title]="title$ | async"
	[isSaving]="isSaving$ | async"
	[isFormInvalid]="invalidSubmission$ | async"
	(save)="save($event)"
></rpshared-save-bar>

<div class="toolbar-margin"></div>

<div [formGroup]="form" gdGap="10px">
	<rpshared-mat-loading-card
		[isLoading]="isLoadingRailroad$ | async"
		icon="train"
		title="General Information"
	>
		<rpfsa-railroad-general-info
			gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
			gdGap="10px"
			formControlName="generalInfo"
			[isExistingRailroad]="isExistingRailroad$ | async"
		></rpfsa-railroad-general-info>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		[isLoading]="isLoadingRailroad$ | async"
		icon="train"
		title="Address"
	>
		<rpshared-address formControlName="address"> </rpshared-address>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="train"
		title="Optional Job Fields"
	>
		<rpfsa-optional-job-fields-to-show
			formControlName="optionalJobFieldsToShow"
		>
		</rpfsa-optional-job-fields-to-show>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="train"
		title="Offered Services"
	>
		<rpfsa-offered-services-list
			formControlName="offeredServices"
		></rpfsa-offered-services-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="assignment"
		title="Sub Codes"
	>
		<rpfsa-sub-codes-list formControlName="subCodes"></rpfsa-sub-codes-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="flag"
		title="Jobs"
	>
		<rpfsa-job-list [jobs]="jobs$ | async"></rpfsa-job-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="supervised_user_circle"
		title="Field Workers"
	>
		<rpfsa-rwic-list [rwics]="rwics$ | async"></rpfsa-rwic-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="contacts"
		title="Contacts"
	>
		<rpshared-contact-list
			formControlName="contacts"
		></rpshared-contact-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="file_copy"
		title="Documents"
	>
		<rpshared-document-list
			[parentId]="id$ | async"
			target="Railroad"
			formControlName="documents"
		></rpshared-document-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="assignment"
		title="Divisions"
	>
		<rpfsa-division-list formControlName="divisions"></rpfsa-division-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="shopping_cart"
		title="Customers"
	>
		<rpfsa-customer-list
			[customers]="customers$ | async"
		></rpfsa-customer-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="attach_money"
		title="Contracted Rates"
	>
		<rpshared-contract-rates-list
			[railroadRegularTimeBasis]="
				form.value.generalInfo?.regularTimeBasis
			"
			formControlName="contractedRates"
			[canMakeChanges]="true"
		></rpshared-contract-rates-list>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="isExistingRailroad$ | async"
		[isLoading]="isLoadingRailroad$ | async"
		icon="attach_money"
		title="Payroll Options"
	>
		<rpfsa-payroll-options
			gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
			gdGap="10px"
			formControlName="payrollOptions"
		>
		</rpfsa-payroll-options>
	</rpshared-mat-loading-card>
</div>
